import { PlayerPosition, PlayerStatus } from "src/app/enums/Index";
import { Model } from "./Model";
import { Sponsor } from "./Index";

export interface Partner extends Model {
	partnerType: string;
	sponsorId: number;
	sponsor: Sponsor;
}

export class Partner implements Partner {

	constructor(data?: Partial<Partner>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}